import {
  Box,
  Dialog,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { Button } from "react-admin";
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import DatePicker from "react-datepicker";
import basketIcon from "../../../assets/icons/basket.svg";
import branchIcon from "../../../assets/icons/branch.svg";
import categoryIcon from "../../../assets/icons/category.svg";
import dayIcon from "../../../assets/icons/day.svg";
import memberWalkinIcon from "../../../assets/icons/member-walkin.svg";
import moment from "moment";
import newMemberIcon from "../../../assets/icons/newmembers.png";
import productIcon from "../../../assets/icons/product.png";
import settings from "../../../utils/settings";
import { useAuthenticated } from "ra-core";
import { useDataProvider } from "ra-core";
import walkinMemberIcon from "../../../assets/icons/walkin-member.svg";

//DrawerComponent
const useStyles = makeStyles(() => ({
  "@global": {
    "@keyframes l5": { to: { "clip-path": "inset(0 -1ch 0 0)" } },
  },

  loader: {
    width: "fit-content",
    fontFamily: "Roboto",
    fontSize: "21px",
    fontWeight: 700,
    color: "var(--Text-Body-text-brand, #FB9D18)",
    "clip-path": "inset(0 100% 0 0)",
    animation: "l5 2s steps(20) infinite",
    overflow: "hidden",
  },
}));
//import useSFSessionTimeout from "../../../hooks/useSFSessionTimeout";
const dateFormat = require("dateformat");

let filter = [
  {
    filterName: "All",
    selected: false,
  },
  {
    filterName: "Day",
    selected: false,
  },
  {
    filterName: "Month",
    selected: false,
  },
  {
    filterName: "Year",
    selected: false,
  },
  {
    filterName: "Custom Date",
    selected: false,
  },
];

const CHARTS = [
  {
    chartId: "d3de5504-8643-46b6-a177-983ca556df0d",
    elementId: "1",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time)
            .subtract(1, "month")
            .startOf("month")
            .toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  {
    chartId: "bf0335fb-85da-4438-b9ac-54178e20d48b",
    elementId: "2",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time).startOf("month").toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  {
    chartId: "8e51cccf-116b-4402-bc08-f4109f873faa",
    elementId: "3",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time).startOf("month").toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  {
    chartId: "aba7668c-fde3-43a4-94ac-a91fe50fc10d",
    elementId: "4",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time).startOf("month").toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  {
    chartId: "23f079eb-3e88-47e0-8d7b-0adea8cf43f2",
    elementId: "5",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time).startOf("month").toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  {
    chartId: "f64f7ae2-e5d7-4f85-b3f8-20ce657f477d",
    elementId: "6",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time).startOf("month").toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  {
    chartId: "df9fc47b-8325-40b8-ba29-8be97bf06370",
    elementId: "7",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time).startOf("month").toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  {
    chartId: "62e89d95-1643-4eeb-9269-4d3cba82e88d",
    elementId: "8",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time).startOf("month").toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  {
    chartId: "e12181e4-a3d1-45b6-a62f-d31ec51de313",
    elementId: "9",
    filter: (filter) => {
      return {
        ...filter,
        create_time: {
          $gte: moment(filter.create_time).startOf("month").toDate(),
          $lte: moment(filter.create_time).endOf("month").toDate(),
        },
      };
    },
  },
  //   { chartId: "", elementId: "3" },
  //   { chartId: "", elementId: "4" },
  //   { chartId: "", elementId: "5" },
  //   { chartId: "", elementId: "6" },
  //   { chartId: "", elementId: "7" },
  //   { chartId: "", elementId: "8" },
  //   { chartId: "", elementId: "9" },
];

function BusinessInsight() {
  const dataProvider = useDataProvider();
  useAuthenticated();
  let { branchId } = settings();
  const [openCalendar, setOpenCalendar] = useState(false);

  const [period, setPeriod] = useState(moment().format("MMM-YYYY"));

  const [productDisplayIcon, setProductDisplayIcon] = useState(productIcon);
  const [revenue, setRevenue] = useState({
    value: "Loading",
    comparison: "-",
  });
  const [channelCardValue, setChannelCardValue] = useState({
    value: "Loading",
  });
  const [customerCardValue, setCustomerCardValue] = useState({
    memberValue: "-",
    walkInValue: "-",
  });
  const [newMemberCardValue, setNewMemberCardValue] = useState({
    value: "Loading",
  });
  const [topTierCardValue, setTopTierCardValue] = useState({
    value: "Loading",
    image_url: null,
    comparison: "-",
  });
  const [averageCardValue, setAverageCardValue] = useState({
    value: "Loading",
  });
  const [topCategoryCardValue, setTopCategoryCardValue] = useState({
    value: "Loading",
  });
  const [topProductCardValue, setTopProductCardValue] = useState({
    value: "Loading",
  });
  const [topDayCardValue, setTopDayCardValue] = useState({
    value: "Loading",
  });

  useEffect(() => {
    async function fetchChart() {
      //fetch data here
      const branches = await dataProvider.getList("merchant-branches", {});
      const tiers = await dataProvider.getList("member-tiers", {});
      setProductDisplayIcon(productIcon);
      if (true) {
        // const jsonResult = await result.json();
        const sdk = new ChartsEmbedSDK({
          baseUrl: process.env.REACT_APP_CHART_DASHBOARD_URL,
          showAttribution: false,
        });
        const filter = {
          create_time: period ? moment(period).toDate() : moment().toDate(),
        };

        if (branchId) filter.branch_id = branchId;

        // console.log(moment().format("MMM-YYYY"));
        const currentPeriodFilter = moment().format("MMM-YYYY");
        for (let i = 0; i < CHARTS.length; i++) {
          const chart = sdk.createChart({
            chartId: CHARTS[i].chartId,
            filter: CHARTS[i].filter ? CHARTS[i]?.filter(filter) : filter,
          });
          chart
            .render(document.getElementById(CHARTS[i].elementId))
            .then(() => {
              chart.getData().then(async (data) => {
                console.log(JSON.stringify(data, null, 0));
                if (i === 0) {
                  if (data.documents) {
                    if (data.documents.length > 1) {
                      setRevenue({
                        value: data.documents[1].value,
                        comparison: data.documents[0]?.value
                          ? ((data.documents[1].value -
                              data.documents[0].value) /
                              data.documents[0].value) *
                            100
                          : "-",
                      });
                    } else if (data.documents.length === 1) {
                      if (data.documents[0].group === currentPeriodFilter)
                        setRevenue({
                          value: data.documents[0].value,
                          comparison: "-",
                        });
                      else setRevenue({ value: 0, comparison: "-" });
                    } else {
                      setRevenue({ value: 0, comparison: "-" });
                    }
                  }
                }
                if (i === 1) {
                  setChannelCardValue({
                    value: branches.data.find(
                      (d) => d.id === data.documents?.[0]?.display
                    )?.name,
                  });
                }
                if (i === 2) {
                  let memberPercent = 0;
                  let walkInPercent = 0;
                  if (
                    data.documents.reduce((acc, cur) => acc + cur.value, 0) !==
                    0
                  ) {
                    memberPercent = Math.round(
                      (data.documents.find((d) => d.group === "Member")?.value *
                        100) /
                        data.documents.reduce((acc, cur) => acc + cur.value, 0)
                    );
                    walkInPercent = 100 - memberPercent;
                  }

                  setCustomerCardValue({
                    memberValue: memberPercent ?? "-",
                    walkInValue: walkInPercent ?? "-",
                  });
                }
                if (i === 3) {
                  setNewMemberCardValue({
                    value: data.documents[0].value ?? "-",
                  });
                }
                if (i === 4) {
                  const sorted = data.documents.sort(
                    (a, b) => b.value - a.value
                  );

                  if (!sorted || sorted.length === 0)
                    return setTopTierCardValue({ value: "-", comparison: "-" });

                  let comparison = Math.round(
                    (sorted[0].value * 100) /
                      sorted.reduce((acc, cur) => acc + cur.value, 0)
                  );
                  if (isNaN(comparison)) comparison = "-";
                  setTopTierCardValue({
                    value: tiers.data.find((d) => d.id === sorted[0].group)
                      ?.name,
                    comparison,
                    image_url: tiers.data.find((d) => d.id === sorted[0].group)
                      ?.image_url,
                  });
                }
                if (i === 5) {
                  if (data.documents.length === 0)
                    return setAverageCardValue({ value: "-" });
                  setAverageCardValue({
                    value: Number(data.documents[0].value).toFixed(2) ?? "-",
                  });
                }
                if (i === 6) {
                  setTopCategoryCardValue({
                    value: data.documents?.[0]?.y ?? "-",
                  });
                }
                if (i === 7) {
                  setTopProductCardValue({
                    value: data.documents?.[0]?.y ?? "-",
                  });

                  const result = await dataProvider.getList("products", {
                    search_term: data.documents?.[0]?.y,
                  });
                  console.log(result.data?.[0]?.image_url);
                  setProductDisplayIcon(result.data?.[0]?.image_url);
                }
                if (i === 8) {
                  const documents = data.documents?.sort((a, b) => b.x - a.x);
                  setTopDayCardValue({
                    value:
                      [
                        "",
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday",
                      ][documents?.[0]?.y] ?? "-",
                  });
                }
              });
            });
        }

        // }
      }
    }
    fetchChart();
  }, [period]);
  return (
    <>
      <Box
        style={{
          height: "0px",
          width: "0px",
          // display: "grid",
          justifyContent: "center",
          alignItems: "center",
          gap: 5,
          marginTop: 40,
          gridTemplateColumns: "repeat(3, 1fr)",
          justifyItems: "center",
        }}
      >
        {CHARTS.map((chart) => {
          return (
            <div id={chart.elementId} style={{ height: 0, width: 0 }}></div>
          );
        })}
        {/* <div id={"1"} style={{ height: "0px", width: "0px" }}></div> */}
      </Box>
      <Box
        style={{
          width: "100%",
          marginTop: 40,
          display: "inline-flex",
          placeContent: "normal",
        }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            right: 0,
            left: 0,
          }}
        >
          <Typography
            style={{
              color: "var(--Text-Header-header-brand, #FB9D18)",
              textAlign: "center",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "Roboto",
              fontSize: "36px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "normal",
            }}
          >
            Today's
          </Typography>
          <Typography
            style={{
              color: "var(--Text-Header-header-brand, #5E584E)",
              textAlign: "center",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "Roboto",
              fontSize: "36px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "normal",
              marginLeft: "1rem",
            }}
          >
            Health check
          </Typography>
        </Box>
        <Button
          style={{
            position: "absolute",
            right: 78,
            backgroundColor: "orange",

            color: "white",
            minWidth: 120,
            height: 30,
          }}
          label={moment(period).format("MMMM YYYY")}
          onClick={() => setOpenCalendar(true)}
        ></Button>
      </Box>
      <Box
        style={{
          display: "grid",
          justifyContent: "center",
          alignItems: "center",
          gap: 20,

          gridTemplateColumns: "repeat(3, 1fr)",
          justifyItems: "center",
          padding: "78px",
        }}
      >
        <InsightCard
          value={revenue?.value.toLocaleString()}
          valueSuffix={"THB"}
          caption={"Revenue"}
        >
          <LogoRevenueCard value={revenue?.comparison} />
        </InsightCard>
        <InsightCard
          value={channelCardValue?.value}
          caption={"Top channel by revenue"}
        >
          <img src={branchIcon} alt="branch-icon" width={46} height={46} />
        </InsightCard>
        <CustomerInsightCard
          memberValue={`${customerCardValue?.memberValue}%`}
          walkInValue={`${customerCardValue?.walkInValue}%`}
        ></CustomerInsightCard>
        <InsightCard value={newMemberCardValue?.value} caption={"New members"}>
          <img
            src={newMemberIcon}
            alt="new-member-icon"
            width={46}
            height={46}
          />
        </InsightCard>
        <InsightCard
          value={topTierCardValue?.value}
          caption={`Contributed of ${topTierCardValue?.comparison}% of revenue`}
        >
          {topTierCardValue.image_url ? (
            <img src={topTierCardValue.image_url} width={46} height={46} />
          ) : null}
        </InsightCard>
        <InsightCard
          value={averageCardValue?.value}
          caption={`Average basket size`}
          valueSuffix={"THB"}
        >
          <img src={basketIcon} alt="basket-icon" width={46} height={46} />
        </InsightCard>
        <InsightCard
          value={topCategoryCardValue?.value}
          caption={`Top category`}
        >
          <img src={categoryIcon} alt="category-icon" />
        </InsightCard>
        <InsightCard
          value={topProductCardValue?.value}
          caption={`High demand product`}
        >
          <img
            src={productDisplayIcon}
            alt="product-icon"
            width={46}
            height={46}
            style={{ "border-radius": "50%" }}
          />
        </InsightCard>
        <InsightCard
          value={topDayCardValue?.value}
          caption={`Peak day of order quantity`}
        >
          <img src={dayIcon} alt="day-icon" width={46} height={46} />
        </InsightCard>
      </Box>
      <Dialog
        local="th"
        open={openCalendar}
        aria-labelledby="f-dialog-title"
        aria-describedby="f-dialog-description"
        PaperProps={{
          style: {
            borderRadius: 12,
          },
        }}
      >
        <DatePicker
          inline
          selected={new Date()}
          onChange={(date) => {
            setPeriod(moment(date).format("MMM-YYYY"));
            setOpenCalendar(false);
            setRevenue({
              value: "Loading",
              comparison: "-",
            });
            setChannelCardValue({
              value: "Loading",
            });
            setCustomerCardValue({
              memberValue: "-",
              walkInValue: "-",
            });
            setNewMemberCardValue({
              value: "Loading",
            });
            setTopTierCardValue({
              value: "Loading",
              image_url: null,
              comparison: "-",
            });
            setAverageCardValue({
              value: "Loading",
            });
            setTopCategoryCardValue({
              value: "Loading",
            });
            setTopProductCardValue({
              value: "Loading",
            });
            setTopDayCardValue({
              value: "Loading",
            });
          }}
          dateFormat="MM/yyyy"
          showMonthYearPicker
        />
      </Dialog>
    </>
  );
}

function LogoRevenueCard({ value }) {
  return (
    <Box style={{ width: "60px", height: "45px", placeContent: "center" }}>
      <Box
        style={{
          display: "flex",
          width: "60px",
          height: "16px",
          flexDirection: "column",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Typography
          style={{
            color:
              value === "-"
                ? "var(--Icon-Status-icon-success, #8BBB4D)"
                : value > 0
                ? "var(--Icon-Status-icon-success, #8BBB4D)"
                : "var(--Icon-Status-icon-danger, #E74C3C)",
            textAlign: "center",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "Roboto",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            whiteSpace: "nowrap",
          }}
        >
          {value === "-" ? "-" : value > 0 ? "▴" : "▾"}{" "}
          {value === "-" ? value : Math.round(value) + "%"}
        </Typography>
      </Box>
      <Typography
        style={{
          color: "var(--Text-Body-text-secondary, #A39F9A)",
          textAlign: "center",
          fontFeatureSettings: "'clig' off, 'liga' off",
          fontFamily: "Roboto",
          fontSize: "6px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "0.5rem",
        }}
      >
        last month
      </Typography>
    </Box>
  );
}

function CustomerInsightCard({ memberValue, walkInValue }) {
  return (
    <Box
      style={{
        width: 280,
        height: 88,
        top: 0,
        left: 0,
        gap: 0,
        borderRadius: "12px",
        opacity: "0px",
        border: "1px solid var(--Border-border-primary-normal, #E8E7E6)",
        background: "#FFF",
        position: "relative",
      }}
    >
      <Box
        style={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "flex-start",
          position: "absolute",
          top: 23,
          left: 18,
        }}
      >
        <img src={memberWalkinIcon} alt="member-icon" />
      </Box>
      <Box style={{ position: "absolute", top: 22, left: 75 }}>
        <Box
          style={{
            display: "flex",
            alignItems: "baseline",
            height: "21px",
          }}
        >
          {" "}
          <Typography
            style={{
              color: "var(--Text-Body-text-brand, #FB9D18)",

              fontFamily: "Roboto",
              fontSize: "21px",
              fontWeight: 700,
              textOverflow: "ellipsis",
              maxWidth: "180px",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {memberValue}
          </Typography>
        </Box>
        <Typography
          style={{
            marginTop: 8,
            color: "var(--Text-Body-text-primary-default, #5E584E)",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "Roboto",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "12px",
          }}
        >
          Members
        </Typography>
      </Box>
      <Box
        style={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "flex-start",
          position: "absolute",
          top: 23,
          left: 125,
        }}
      >
        <img src={walkinMemberIcon} alt="walkin-icon" />
      </Box>
      <Box style={{ position: "absolute", top: 22, left: 180 }}>
        <Box
          style={{
            display: "flex",
            alignItems: "baseline",
            height: "21px",
          }}
        >
          {" "}
          <Typography
            style={{
              color: "var(--Text-Body-text-brand, #FB9D18)",

              fontFamily: "Roboto",
              fontSize: "21px",
              fontWeight: 700,
              textOverflow: "ellipsis",
              maxWidth: "180px",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {walkInValue}
          </Typography>
        </Box>
        <Typography
          style={{
            marginTop: 8,
            color: "var(--Text-Body-text-primary-default, #5E584E)",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "Roboto",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "12px",
          }}
        >
          Walk-ins
        </Typography>
      </Box>
    </Box>
  );
}

function InsightCard({ value, valueSuffix, caption, children }) {
  const classes = useStyles();
  return (
    <Box
      style={{
        width: 280,
        height: 88,
        top: 0,
        left: 0,
        gap: 0,
        borderRadius: "12px",
        opacity: "0px",
        border: "1px solid var(--Border-border-primary-normal, #E8E7E6)",
        background: "#FFF",
        position: "relative",
      }}
    >
      <Box
        style={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "flex-start",
          position: "absolute",
          top: 23,
          left: 18,
        }}
      >
        {children}
      </Box>
      <Box style={{ position: "absolute", top: 22, left: 75 }}>
        <Box
          style={{
            display: "flex",
            alignItems: "baseline",
            height: "21px",
          }}
        >
          {" "}
          {value === "Loading" ? (
            <Box className={classes.loader}>Loading...</Box>
          ) : (
            <Tooltip title={value}>
              <Typography
                style={{
                  color: "var(--Text-Body-text-brand, #FB9D18)",

                  fontFamily: "Roboto",
                  fontSize: "21px",
                  fontWeight: 700,
                  textOverflow: "ellipsis",
                  maxWidth: "180px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                {value}
              </Typography>
            </Tooltip>
          )}
          <Typography
            style={{
              color: "var(--Text-Body-text-primary-default, #5E584E)",

              fontFamily: "Roboto",
              fontSize: "12px",

              fontWeight: 700,
              marginLeft: "5px",
            }}
          >
            {" "}
            {valueSuffix}
          </Typography>
        </Box>
        <Typography
          style={{
            marginTop: 8,
            color: "var(--Text-Body-text-primary-default, #5E584E)",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "Roboto",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "12px",
          }}
        >
          {caption}
        </Typography>
      </Box>
    </Box>
  );
}

export default BusinessInsight;
